<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>提现维护</el-breadcrumb-item>
      <el-breadcrumb-item>提现管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="10">
          <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
            style="width:300px " @clear="gettixianList" @change="gettixianList">
            <el-button slot="append" icon="el-icon-search" @click="gettixianList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="get_tixian_add" v-if="admin_flag === 0">提现申请</el-button>
        </el-col>
        <el-col :span="10"  style="text-align: right;" >
                    <el-button type="primary" @click="handleExport()">导出电子表格</el-button>
                </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="tixianList" style="width: 100%" border stripe id="report">
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
            <el-table-column prop="guest_bianhao" label="客户编号" width="80" v-if="type === 1"></el-table-column>
            <el-table-column prop="guest_name" label="客户名称" width="80" v-if="type === 1"></el-table-column>
            <el-table-column prop="qiye_bianhao" label="店铺编号" width="80" v-if="type === 2"></el-table-column>
            <el-table-column prop="qiye_name" label="店铺名称" width="80" v-if="type === 2"></el-table-column>
            <el-table-column prop="yuangong_bianhao" label="员工编号" width="80" v-if="type === 3"></el-table-column>
            <el-table-column prop="yuangong_name" label="员工姓名" width="80" v-if="type === 3"></el-table-column>
            <el-table-column prop="tixian_money" label="金额" width="120"></el-table-column>
            <el-table-column prop="tixian_sxf" label="手续费"></el-table-column>
            <el-table-column prop="add_time" label="时间"></el-table-column>
            <el-table-column label="审核状态">
              <template v-slot="scope">
                <span style="color: brown;">{{ scope.row.tixian_sh_flag === 1 ? '已处理' : '未处理' }} </span>
              </template>
            </el-table-column>

            <el-table-column prop="add_time" label="加入时间"></el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">

                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                  <el-button type="danger" icon="el-icon-delete" circle size="mini"
                    @click="deleteForm(scope.row.uid)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="提现确认" placement="top" :enterable="false"
                  v-if="admin_flag === 1">
                  <el-button type="success" icon="el-icon-orange" @click="tixianForm(scope.row.uid)" circle
                    size="mini"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>
      <!-- 提现窗口 -->

      <el-dialog title="提现" :visible.sync="huifangDialogVisible" width="50%" @close="huifangDoalogClosed">

      </el-dialog>
      <!-- 添加提现部分 -->
      <el-dialog title="添加提现" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
        <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="提现编号" prop="tixian_bianhao">
            <el-input v-model="addForm.tixian_bianhao" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="提现金额" prop="tixian_money">
            <el-input v-model="addForm.tixian_money" width="10"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addtixian" :disabled="add_isDisable">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改提现信息 -->
      <el-dialog title="" :visible.sync="editDialogVisible" width="50%" @close="editDoalogClosed">
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from './config/validator';
import exportExcel from './config/exportExcel'
export default {
  props: [
    'admin_flag',
    'type' // 提现到类型 1 客户 2 门店 3员工
  ],
  data() {
    return {
      tixianLy_options: [
        {
          value: 1,
          label: '提现介绍'
        },
        {
          value: 2,
          label: '提现'
        },
        {
          value: 3,
          label: '上门提现'
        }
      ],
      tixian_options: [
        {
          value: 1,
          label: '初级提现'
        },
        {
          value: 2,
          label: '中级提现'
        },
        {
          value: 3,
          label: '高级提现'
        }
      ],
      // 获取用户列表参数
      queryInfo: {
        C_type: 'get_list',
        C_table_name: 'tixian_list',
        query: '',
        pageNum: 1,
        pageSize: 10,
        qiye_uid: window.sessionStorage.getItem('qiye_uid')
      },
      huifang_isDisable: false,
      add_isDisable: false,
      tixianList: [],
      xiaoquList: [],
      gudongList: [],
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      huifangDialogVisible: false,

      // 用于设置页面滑块值
      //  添加表单数据项
      huifangForm: {
        C_type: 'huifang_add',
        huifang_tixian_uid: 0,
        huifang_title: '',
        hufiang_memo: '',
        huifang_genjin: 1,
        huifang_yuangong_uid: 0,
        huifang_switch: true
      },
      addForm: {
        C_type: 'tixian_add',
        tixian_bianhao: '',
        tixian_money: 0
      },
      // 用于修改数据绑定
      editForm: {},
      // 表单规则项
      addFormRules: {
        tixian_money: [
          { required: true, message: '不能为空', trigger: 'blur' },
          { required: true, pattern: /^(([1-9][0-9]{0,3})|0|1000000)$/, message: '请输入0-10000数字', trigger: 'change' }
        ]
      }
    };
  },
  created() {
    this.gettixianList();
    // this.getXiaoquList()
  },
  methods: {
    handleExport() {
      exportExcel('report', '导出.xlsx')
    },
    async getXiaoquList() {
      const { data: res } = await this.$http.get('get_api', {
        params: {
          C_type: 'xiaoqu_list_select' // 调用普通api get接口 
        }
      });
      this.xiaoquList = JSON.parse(res.data)[0].dataList
      console.log(this.xiaoquList)
    },
    async getGudongList(xiaoquUid) {
      const { data: res } = await this.$http.get('get_api', {
        params: {
          C_type: 'gudong_list_select', // 调用普通api get接口 
          xiaoqu_uid: xiaoquUid
        }
      });
      this.gudongList = JSON.parse(res.data)[0].dataList
      console.log(this.gudongList)
    },
    get_switch_value(switchValue) {
      this.huifangForm.huifang_genjin = switchValue ? 1 : 0;
      console.log(this.huifangForm.huifang_genjin);
    },
    async huiFangAdd() {
      const { data: res } = await this.$http.post('api', this.huifangForm);
      console.log(JSON.parse(res.data)[0].bianhao_s);
      this.huifangDialogVisible = true;
    },
    async get_tixian_add() {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_type: 'get_bianhao', C_table_type: 11 }
      });
      console.log(JSON.parse(res.data)[0].bianhao_l);
      this.addForm.tixian_bianhao = JSON.parse(res.data)[0].bianhao_l;
      // this.total = JSON.parse(res.data)[0].total
      this.addDialogVisible = true;
    },

    async gettixianList() {
      console.log(998, this.type)
      if (this.type === 1) this.queryInfo.C_table_name = 'tixian_list_guest'
      if (this.type === 2) this.queryInfo.C_table_name = 'tixian_list_qiye'
      if (this.type === 3) this.queryInfo.C_table_name = 'tixian_list_yuangong'
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
      console.log(JSON.parse(res.data))
      this.tixianList = JSON.parse(res.data)[0].dataList;

      if (!this.tixianList) return;
      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total)
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.gettixianList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.gettixianList();
    },

    async addtixian() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return 1;
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        const { data: res } = await this.$http.post('api', this.addForm);
        console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status === 201) {
          this.$message.error('账号错误，请联系管理员')
          return
        } else if ((JSON.parse(res.data)[0].status === 202)) {
          this.$message.error('账户余额不足！')
          return
        } else if ((JSON.parse(res.data)[0].status !== 200)) {
          this.$message.error('提现失败')
          return
        }
        this.$message.success('提现成功');
        this.gettixianList();
        this.addDialogVisible = false;
      });
    },
    async addHuifang() {
      this.$refs.huifangFormRef.validate(async valid => {
        if (!valid) return 1;
        this.huifang_isDisable = true
        setTimeout(() => {
          this.huifang_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)

        const { data: res } = await this.$http.post('api', this.huifangForm);
        console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('添加失败');
          return;
        }
        this.$message.success('添加成功');
        this.gettixianList();
        this.huifangDialogVisible = false;
      });
    },
    showEditDialog(uid) {
      this.tixianInfo(uid);
      this.editDialogVisible = true;
    },
    addDoalogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    huifangDoalogClosed() {
      this.$refs.huifangFormRef.resetFields();
    },
    showHuifangDialog(uid) {
      this.huifangDialogVisible = true;
      this.tixianInfo(uid);
    },
    editDoalogClosed() {
      this.$refs.editFormRef.resetFields();
    },
    async tixianInfo(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'tixian_info', uid: uid, C_type: 'get_info' }
      });
      // console.log(JSON.parse(res.data))
      console.log(res.data);
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }

      this.editForm = JSON.parse(res.data)[0].data[0];
      this.huifangForm.huifang_tixian_uid = JSON.parse(res.data)[0].data[0].uid;
    },
    async updatetixian() {
    },
    // 删除一条记录
    async deleteForm(tixianUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确定删除该条记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'tixian_del',
        C_data1: tixianUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败');
        return;
      }
      this.$message.success('删除成功');
      this.gettixianList();
    },
    // 删除一条记录
    async tixianForm(tixianUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确认该条提现记录吗?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'tixian_queren',
        tixianUid: tixianUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('确认失败');
        return;
      }
      this.$message.success('确认成功');
      this.gettixianList();
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
  background-color: #f2f6fc;
}

.el_row_two {
  margin-top: 30px;
}
</style>
